/* eslint-disable react/prop-types */
import React from 'react';
import MUIAlert from '@material-ui/lab/Alert';
import styled from 'styled-components';

const Alert = styled(MUIAlert)`
  background-color: ${
    // @ts-ignore
    ({ theme }) => theme.colors.secondary
  } !important;
  color: ${
    // @ts-ignore
    ({ theme }) => theme.colors.primary
  } !important;
`;

const Toast = React.forwardRef(({ children, ...props }, ref): JSX.Element => (
  <Alert severity="info" variant="filled" ref={ref} {...props}>
    {children}
  </Alert>
));

export default Toast;
